import React from 'react';
import { ShortEventsList } from 'src/components/TradingEvents/ShortEventsList/ShortEventsList';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';

export const RecentEventsList = observer('RecentEventsList', () => {
    const { sportsbookState } = useAppStateContext();
    const events: Array<number> = sportsbookState.eventPageState.recentlyViewed;

    return (
        <ShortEventsList
            events={ events }
        />
    );
});
